export default {

  // 新增标书管理
  insertYcBidDocument: '/ygsjzs/ycnBidDocument/insertYcnBidDocument',
  // 修改标书管理
  updateYcBidDocument: '/ygsjzs/ycnBidDocument/updateYcnBidDocument',
  // 中标生成采购订单/废标
  addYcBidDocument: '/ygsjzs/ycnBidDocument/addYcnBidDocument',
  // 供应商报名
  updateYcBidSupplier: '/ygsjzs/ycnBidDocument/updateYcnBidSupplier',
  // 查询供应商报名详情
  selectYcBidSupplierByRelId: '/ygsjzs/ycnBidDocument/selectYcnBidSupplierByRelId',
  // 删除标书管理
  deleteYcBidDocument: '/ygsjzs/ycnBidDocument/deleteYcnBidDocument',
  // 查询标书管理详情
  selectYcBidDocumentByBidId: '/ygsjzs/ycnBidDocument/selectYcnBidDocumentByBidId',
  // 数字统计/分页查询标书管理列表
  selectYcBidDocumentCount: '/ygsjzs/ycnBidDocument/selectYcnBidDocumentCount',
  // 分页查询标书管理列表
  selectYcBidDocumentByPage: '/ygsjzs/ycnBidDocument/selectYcnBidDocumentByPage'

}
